module.exports = __webpack_public_path__ + "static/img/piscinaClubSocial.ba5fa662.jpg";